import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { Theme, ThemedView } from '@app/theme'
import { getContactNumberForCall, getContactNumberForWhatsapp, getLabelForCall, isIframe, trackEvent } from '@app/utils'
import { ThemedText } from '@app/theme/Components'
import WhatsAppIcon from './../../assets/Icons/Whatsapp';
import LogoutIcon from './../../assets/Icons/LogoutIcon';
import { useAppSelector } from '@app/store/hooks';
import useSingleRemoteConfig from '@app/hooks/useSingleRemoteConfig';
import PhoneIcon from './../../assets/Icons/PhoneIcon';
import { useTheme } from '@shopify/restyle';



interface AppBarWebProps {
    isFromInvestWellSDK: boolean
    showDefaultVoltLogo: string
    customLogoUrl: string
    showSupportPhoneNumber: boolean
    showLogout: boolean
    platform: string
    toggleModal: () => void
}


const AppBarWeb = ({ isFromInvestWellSDK, platform, toggleModal, showDefaultVoltLogo, customLogoUrl, showSupportPhoneNumber, showLogout }: AppBarWebProps) => {

    const { colors } = useTheme<Theme>()

    const isAuthenticated = useAppSelector(state => state.auth?.isAuthenticated);
    const name = useAppSelector(state => state?.auth?.userDetails?.user?.fullName);
    const applicationState = useAppSelector(state => state?.auth?.userDetails?.linkedApplications[0]?.applicationState);
    const phoneNumber = useAppSelector(state => state.commonReducer.phoneNumber);
    const showCall = useAppSelector((state) => state.platformParams.showCall); 




    const whatsAppSupportNumber = useSingleRemoteConfig('contact_support_number_whatsapp')
    const contact_support_number = useSingleRemoteConfig('contact_support_number')
    const contact_support_number_pre_dashboard = useSingleRemoteConfig('contact_support_number_pre_dashboard')


    const finalContactSupportNumber = applicationState === 'COMPLETED' ? contact_support_number?.configValue : contact_support_number_pre_dashboard?.configValue
    

    return (
        <ThemedView style={[styles?.container, {
            alignItems: isFromInvestWellSDK ? 'center' : 'flex-end',
            justifyContent: isFromInvestWellSDK ? 'flex-end' : 'space-between',
        }]} height={60}>
            {isFromInvestWellSDK ? null : (
                <Image
                    style={{ width: 64, height: 24 }}
                    source={{
                        uri:
                            showDefaultVoltLogo === 'false'
                                ? customLogoUrl
                                : 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg',
                    }}
                />
            )}
            <ThemedView
                flexDirection='row'
                alignItems='center'
            >
                <ThemedText variant='b3r'>Need help?</ThemedText>
                {isFromInvestWellSDK ? null : (
                    <View style={{ width: 16, height: 16 }} />
                )}
                {showCall && isAuthenticated && showSupportPhoneNumber && !isFromInvestWellSDK && (
                    <TouchableOpacity
                        onPress={() => {
                            trackEvent('HEADER_CALL_BUTTON_CLICKED');
                            window.open(
                                finalContactSupportNumber
                                    ? `tel:${finalContactSupportNumber}`
                                    : `tel:${getContactNumberForCall(platform, finalContactSupportNumber ?? '')}`,
                                '_parent',
                            );
                        }}>
                        <ThemedView flexDirection='row' alignItems='center'>
                            <PhoneIcon color={colors['icon-action-primary']} size={18} />
                            <ThemedText variant='b3r' color='text-action-primary' ml='xs'>{phoneNumber ? phoneNumber : finalContactSupportNumber ? finalContactSupportNumber : getLabelForCall(platform, finalContactSupportNumber ?? '')}</ThemedText>
                        </ThemedView>
                    </TouchableOpacity>
                )}
                {isFromInvestWellSDK || !showSupportPhoneNumber ? (
                    <ThemedView width={6} />
                ) : (
                    <ThemedView width={10} />
                )}
                <TouchableOpacity
                    onPress={() => {
                        trackEvent('HEADER_WA_BUTTON_CLICKED');
                        if (isIframe()) {
                            window.open(
                                `https://wa.me/${getContactNumberForWhatsapp(platform)}`,
                                '_blank', whatsAppSupportNumber?.configValue ?? ''
                            );
                        } else {
                            window.open(
                                `https://api.whatsapp.com/send?phone=${getContactNumberForWhatsapp(
                                    platform, whatsAppSupportNumber?.configValue ?? ''
                                )}`,
                            );
                        }
                    }}>

                    <ThemedView flexDirection='row' alignItems='center'>
                        <WhatsAppIcon />
                        {isFromInvestWellSDK ? (
                            <ThemedText ml='sm' color='text-action-primary' variant='b3r'>WhatsApp us</ThemedText>
                        ) : (
                            <ThemedText ml='xs' color='text-action-primary' variant='b3r'>Chat with us</ThemedText>
                        )}
                    </ThemedView>
                </TouchableOpacity>

                {!isAuthenticated ? (
                    <></>
                ) : (
                    <>
                        {isFromInvestWellSDK || showLogout == false ? null : (
                            <>
                                <ThemedView width={16} height={16} />
                                <TouchableOpacity
                                    onPress={() => {
                                        trackEvent('LOGOUT_BUTTON_CLICKED', { source: 'header' });
                                        toggleModal();
                                    }}>
                                    <ThemedView flexDirection='row' alignItems='center'>
                                        <LogoutIcon />
                                        <ThemedText ml='xs' color='text-action-primary' variant='b3r'>Logout</ThemedText>
                                        <ThemedText color='text-action-primary' variant='b3r'>{name ? `, ${name}` : ''}</ThemedText>
                                    </ThemedView>
                                </TouchableOpacity>
                            </>
                        )}
                    </>
                )}
            </ThemedView>
        </ThemedView>
    )
}

export default AppBarWeb

const styles = StyleSheet.create({

    container: {
        height: 60,
        width: '100%',
        backgroundColor: '#ffffff',
        marginBottom: 24,
        padding: 40,
        paddingTop: 20,
        paddingBottom: 20,
        flexDirection: 'row',
    },
    needHelp: {
        fontFamily: "Inter",
        fontSize: 14
    }
})